import React, { Component } from "react";
import UI from "../../shared/Components/UI/js";
import MainLayout from "../_components/MainLayout";
import { DeletedDoctorDetails } from "../../ComponentsFC/admin/doctor-accounts/deleted-doctors/index";

const context = "admin";
export default class AdminDoctorAttendance extends Component {
  constructor() {
    super();
    this.state = {};
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "Doctor Accounts",
      context: context,
    });
  }

  render() {
    const _this = this;

    return (
      <MainLayout context={context} _this={_this}>
        <DeletedDoctorDetails />
      </MainLayout>
    );
  }
}
